import oneinchApi from '@/services/oneinch-api'
import type {
  AllowanceResponse,
  ApproveResponse,
  SpenderResponse,
  SwapResponse,
  OneInchErrorResponse,
  QuoteResponse,
} from './types'

export const OneinchV2Service = {
  checkAllowance(apiKey: string, chainId: number, token: string, wallet: string) {
    return oneinchApi.get<AllowanceResponse | OneInchErrorResponse>(
      `/${chainId}/approve/allowance`,
      {
        params: { tokenAddress: token, walletAddress: wallet },
        headers: { Authorization: `Bearer ${apiKey}` },
      },
    )
  },
  approve(apiKey: string, chainId: number, token: string) {
    return oneinchApi.get<ApproveResponse | OneInchErrorResponse>(
      `/${chainId}/approve/transaction`,
      {
        params: { tokenAddress: token },
        headers: { Authorization: `Bearer ${apiKey}` },
      },
    )
  },
  fetchSpender(apiKey: string, chainId: number) {
    return oneinchApi.get<SpenderResponse | OneInchErrorResponse>(
      `/${chainId}/approve/spender`,
      {
        headers: { Authorization: `Bearer ${apiKey}` },
      },
    )
  },
  fetchSwapCalldata(
    apiKey: string,
    chainId: number,
    tokenFrom: string,
    tokenTo: string,
    walletAddress: string,
    amount: string,
    slippage: string | null,
  ) {
    return oneinchApi.get<SwapResponse | OneInchErrorResponse>(
      `/${chainId}/swap`,
      {
        params: {
          src: tokenFrom,
          dst: tokenTo,
          amount: amount,
          from: walletAddress,
          slippage: slippage ?? undefined,
          disableEstimate: 'true',
        },
        headers: { Authorization: `Bearer ${apiKey}` },
      },
    )
  },
  fetchQuote(apiKey: string, chainId: number, tokenFrom: string, tokenTo: string, amount: string) {
    return oneinchApi.get<QuoteResponse | OneInchErrorResponse>(
      `/${chainId}/quote`,
      {
        params: { src: tokenFrom, dst: tokenTo, amount: amount },
        headers: { Authorization: `Bearer ${apiKey}` },
      },
    )
  },
}
